import cacheAngularTemplate from './cacheAngularTemplate';

export default cacheAngularTemplate;
